import React from "react";

const RejectOthersModal = ({
  modalIsOpen,
  handleButtonClick,
  handleSubmit,
  to,
  setTo,
  subject,
  setSubject,
  message,
  setMessage,
  handleCloseModal,
}) => {
  return (
    <div>
      {modalIsOpen && (
        <>
          <div className="fixed inset-0 flex items-center justify-center z-9999">
            <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
            <div className="bg-white w-80 md:w-6/12 rounded shadow-lg z-10">
              <h1 className="px-4 pt-2 font-semibold text-lg">
                Rejection Email for others
              </h1>
              <form onSubmit={handleSubmit}>
                <div className="p-4">
                  <div className="py-2">
                    <label className="block text-gray-700 text-sm font-semibold mb-2">
                      Subject<span className="text-error">*</span>
                    </label>
                    <input
                      className="inputs"
                      type="text"
                      id="username"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      placeholder="Enter Subject"
                      required
                    />
                  </div>
                  <div className="py-2">
                    <label className="block text-gray-700 text-sm font-semibold mb-2">
                      Message
                    </label>
                    <textarea
                      className="inputs overflow-auto scrollbar-thin"
                      type="text"
                      id="username"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      rows={5}
                      placeholder="Enter Message"
                    />
                  </div>
                </div>
                <div className="flex items-center bg-gray-100 justify-end">
                  {/* <div className="px-4 py-2">
                    <button
                      type="button"
                      className="btn-cancel text-white font-medium"
                      onClick={handleCloseModal}
                    >
                      Close
                    </button>
                  </div> */}
                  <div className="px-4 py-2">
                    <button
                      type="submit"
                      className="btn-submit text-white font-medium"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RejectOthersModal;
